export const CustomBothIncentivesIcon = () => {
    const uniqueId = `both-incentives-${Math.random().toString(36).substring(2, 9)}`;
    const maskId = `mask-${uniqueId}`;
    const gradientId = `gradient-${uniqueId}`;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <mask
                id={maskId}
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
            >
                <rect width="16" height="16" fill="#D9D9D9" />
            </mask>
            <g mask={`url(#${maskId})`}>
                <path
                    d="M6.13337 5.5L7.90004 2H8.10004L9.86671 5.5H6.13337ZM7.50004 13.4L1.75004 6.5H7.50004V13.4ZM8.50004 13.4V6.5H14.25L8.50004 13.4ZM10.9667 5.5L9.23337 2H12.6667L14.4167 5.5H10.9667ZM1.58337 5.5L3.33337 2H6.76671L5.03337 5.5H1.58337Z"
                    fill={`url(#${gradientId})`}
                />
            </g>
            <defs>
                <linearGradient
                    id={gradientId}
                    x1="14.4167"
                    y1="7.7"
                    x2="1.58337"
                    y2="7.7"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.2" stopColor="var(--blue-x10)" />
                    <stop offset="0.8" stopColor="var(--purple-x10)" />
                </linearGradient>
            </defs>
        </svg>
    );
};
